export const heroPets = require('./hero-pets.jpg');
export const pawLogo = require('./paw.png');
export const pet = require('./pet.jpg');
export const profile = require('./profile.webp');
export const dogTreat = require('./Dogs/treats.webp');
export const dogLeash = require('./Dogs/leash.webp');
export const dogToys = require('./Dogs/toys.webp');
export const dogGrooming = require('./Dogs/grooming.webp');
export const dogBedding = require('./Dogs/bedding.webp');
export const dogClothing = require('./Dogs/clothing.webp');
export const catClothing = require('./Cats/clothing.webp');
export const catTreat = require('./Cats/treat.webp');
export const catToys = require('./Cats/toys.webp');
export const catLitter = require('./Cats/litter.webp');
export const catGrooming = require('./Cats/grooming.webp');
export const catBedding = require('./Cats/bedding.webp');
export const essPuppy = require('./Essentials/Puppy.jpg');
export const essKitten = require('./Essentials/Kitten.jpg');
export const essSmall = require('./Essentials/small.jpg');
export const valueQty = require('./Values/quality.png');
export const valueTrust = require('./Values/trust.png');
export const valueSprt = require('./Values/support.png');
export const valueDlry = require('./Values/delivery.png');
export const valueBag = require('./Values/bag.png');
export const brandPetmate = require('./Brands/petmate.png');
export const brandPurina = require('./Brands/purina.png');
export const brandKong = require('./Brands/kong.png');
export const brandBayer = require('./Brands/bayer.png');
export const brandRuffwear = require('./Brands/ruffwear.png');
export const forget = require('./Gif/forget.gif');
export const login = require('./Gif/login.gif');
export const logout = require('./Gif/logout.gif');
export const signup = require('./Gif/sign-up.gif');
export const orderPlaced = require('./Gif/placed.gif');
export const facebook = require('./Svg/facebook.png');
export const google = require('./Svg/google.png');
export const metamask = require('./Svg/metamask.png');
export const boneChew = require('./Dogs/Product/bone-chew.webp');
export const dentastix = require('./Dogs/Product/dentastix.webp');
export const duoStick = require('./Dogs/Product/duo-stick.webp');
export const mini = require('./Dogs/Product/mini.webp');
export const sara = require('./Dogs/Product/sara.webp');
export const yummy = require('./Dogs/Product/yummy.webp');